export class GrupoNotificacao {
  constructor({
    id = null,
    assunto = null,
    notificacao = null,
    grupos = null,

  }) {
    this.id = id;
    this.assunto = assunto;
    this.notificacao = notificacao;
    this.grupos = grupos;
  }
  static Build() {
    return new GrupoNotificacao({
      id: null,
      assunto: null,
      notificacao: null,
      grupos: null,
    });
  }
  formatParaEnviar() {
    return {
      id: this.id,
      assunto: this.assunto,
      notificacao: this.notificacao,
      grupos: this.grupos.map((grupo) => grupo.id),
    };
  }
}
